<template>
  <router-view />
</template>

<script>

export default {
  name: 'Samples',
};
</script>
